import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import LoginScreen from "./app/features/screens/auth/loginscreen";
import DashboardLayout from "./layoutes/layout";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./assets/demo/flags/flags.css";
import "./assets/demo/Demos.scss";
import "./assets/layout/layout.scss";
import "./styles/app.scss";
import "./styles/form.scss";
import "./styles/login.scss";
import "./styles/dashboard.scss";
import "./styles/file-input-custom.scss";
import NotFoundPage from "./app/features/components/not_found";
import DashboardScreen from "./app/features/screens/dashboard/dashboard";
import KioskManagement from "./app/features/screens/kiosk-management/kiosk_management";
import MainCustomerService from "./app/features/screens/customer-services-management/main_customer_services_management";
import MachineManagement from "./app/features/screens/machine-management/machine_management";
import AlertNotification from "./app/features/screens/alert-notification/alert_notification";
import MainUserManagement from "./app/features/screens/user-management/main_user_management";
import BranchManagementScreen from "./app/features/screens/branch-management/branch_management";
import UserActivityReport from "./app/features/screens/user-activity-reports/user_activity_report";
import SecurityAccessControl from "./app/features/screens/Security-Access-Control/security_access_control";
import ServiceModeScreen from "./app/features/screens/service-mode/service-mode";
import QueueManagementScreen from "./app/features/screens/queue-management/queue-management";

const App = () => {
  const ProtectedRoute = ({ children }) => {
    const isLoggedIn = localStorage.getItem("accessToken");
    return isLoggedIn ? children : <Navigate to="/login" />;
  };

  const LoginRedirect = () => {
    const isLoggedIn = localStorage.getItem("accessToken");
    return isLoggedIn ? <Navigate to="/" /> : <LoginScreen />;
  };

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<LoginRedirect />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<DashboardScreen />} />
          <Route path="/user-management" element={<MainUserManagement />} />
          <Route path="/branch-management" element={<BranchManagementScreen />} />
          <Route path="/kiosk-management" element={<KioskManagement />} />
          <Route path="/main-customer-services-management" element={<MainCustomerService />} />
          <Route path="/machine-management" element={<MachineManagement />} />
          <Route path="/service-mode" element={<ServiceModeScreen />} />
          <Route path="/user-activity-reports" element={<UserActivityReport />} />
          <Route path="/security-access-control" element={<SecurityAccessControl />} />
          <Route path="/queue-management" element={<QueueManagementScreen />} />
          <Route path="/alert-notification" element={<AlertNotification/>} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;
